import { useMemo } from "react";
import {
  DealQuestionnaireScores,
  DealQuestionnaireSettings,
  Score as DealScoreType
} from "@/pages/deals/types";
import { ScoreType } from "@/pages/deals/scoreConfig";
import { find } from "lodash";

interface UseKPIScoresProps {
  questionnairesSettings: DealQuestionnaireSettings;
  questionnairesScores: DealQuestionnaireScores;
}

interface KPIScoreValue {
  questionnaireId: string;
  score: DealScoreType | null;
}

export const useKPIScores = ({
  questionnairesSettings,
  questionnairesScores
}: UseKPIScoresProps): Record<ScoreType, KPIScoreValue> => {
  const kpiToScoreValueMap = useMemo(
    () =>
      Object.values(questionnairesSettings).reduce(
        (acc, fullResponse) => {
          if (!fullResponse?.data?.questionnaires) {
            return acc;
          }
          const scoresData = Object.values(questionnairesScores)
            .flatMap((value) => value?.data?.scores)
            .filter(Boolean);

          fullResponse?.data?.questionnaires.forEach((questionnaire) => {
            if (questionnaire.kpiValue) {
              const score =
                find(
                  scoresData,
                  (questionnaireWithScore) =>
                    questionnaireWithScore?.questionnaireId === questionnaire.id
                ) || null;
              acc[questionnaire.kpiValue as ScoreType] = {
                questionnaireId: questionnaire.id,
                score
              };
            }
          });

          return acc;
        },
        {} as Record<ScoreType, KPIScoreValue>
      ),
    [questionnairesSettings, questionnairesScores]
  );

  return kpiToScoreValueMap;
};
